
import { Component, Vue, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import router from '@/router';
import vPagination from '@/components/VuePlainPagination.vue';
import Axios from 'axios';
import NevronHeader from '@/components/NevronHeader.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronClickConfirm from '@/components/NevronClickConfirm.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import CreateCrew from '../../../modules/CrewCast/Crew/create.vue';
import PerPageDropdown from '../../../components/PerPageDropdown.vue';
import _ from 'lodash';

@Component({
  components: {
    vPagination,
    NevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    NevronClickConfirm,
    CreateCrew,
    PerPageDropdown,
  },
})

export default class CrewList extends Vue {
  response: any = null;
  items = stores.Package;

  firstLoad = true;
  perpage = 20;

  search: any = {
    query: '',
    current: '',
  };

  indexList: number[] = [];
  allChecked: boolean = false;

  searchItems = _.debounce(() => {this.fetchData(1, this.search.query, this.perpage); }, 400); // fetches data with debounce (ms)

  mounted() {
    console.log('response');
  }

  // openItem(itemId: string | number) {
  //   this.$router.push({name: 'packages.show', params: {id: String(itemId)}, query: {lastpage: this.response.currentPage, perpage: String(this.perpage)}});
  // }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }
  /* when item is checked */
  updateCheck() {
    if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }
  get itemIds(): number[] {
    // @ts-ignore
    return this.items.map((item: any) => item.id);
  }

  unknownClicked() {
    return null;
    // return new Promise((resolve, reject) => {
    //   axios.put(`/protected/accounts/search/set`,
    //   {
    //     ids: this.indexList,
    //     operation: 'unknown',
    //   })
    //   .then((response) => {
    //     console.log(response);
    //   }).catch((e) => {
    //     console.log(e);
    //     reject(e);
    //   });
    // });
  }

  refresh() {
    this.fetchData(this.response.currentPage, null, this.perpage);
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null, perpage: number | 20) {
    return stores.Package.fetchData(index, search, perpage)
      .then((response) => {
        // wrong page
        // if (response.currentPage < 0) {
        //   this.fetchData(1, search, perpage);
        // } else if (response.currentPage > response.lastPage) {
        //   this.fetchData(response.lastPage, search, perpage);
        // } else {
        //   this.response = response;
        //   this.items = this.response.data;
        //
        //   // TODO to je treba rešiti lepše
        //   // če je page=1 potem tega ne dodamo :)
        //   if (this.search.query === '') {
        //     this.$router.push({query: {page: String(this.response.currentPage)}});
        //   } else {
        //     this.$router.push({query: {page: String(this.response.currentPage), search: this.search.query}});
        //   }
        //   this.search.current = this.search.query;
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
